export default "__VITE_ASSET__440if12D__"